export default __webpack_public_path__ + "static/media/user-loader.9272e18c.gif";